import React from 'react';
import { TWConfirmModal } from '../../../../components/ui';

export default function DeleteHidedateModal({
  show,
  loading,
  onClose,
  onSubmit,
}) {
  return (
    <TWConfirmModal
      open={show}
      onClose={onClose}
      onConfirm={onSubmit}
      loading={loading}
      tone="warning"
      title="Remove Hide Date"
      description="Are you sure you want to remove this hide date? This option will be visible in the menu."
      confirmLabel="Remove"
      cancelLabel="Cancel"
    />
  );
}
